import { useCallback } from 'react';

import { useLocale } from '@tanium/react-locale-context';

import { percentFormatter } from '../formatters/percentFormatter';
import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormatterType } from '../utils/NumberFormatterType';

/**
 * Hook that returns a locale aware percent value formatter.
 */
export const useLocalizedPercentFormatter = (): NumberFormatterType => {
  const locale = useLocale();
  return useCallback((value: NumberCoercible) => percentFormatter(value, locale), [locale]);
};
